import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
  	isLogin : false,
  	user : null,
    panel: null,
    panelData: {},
    validityPlans : {},
    basePrice : 0
  },
  getters: {
    getLoginStatus: state => {
      return state.isLogin;
    },
    getUser: state => {
      return state.user;
    },
    getPanel: state => {
      return state.panel;
    },
    getPanelData: state => {
      return state.panelData;
    },
    getValidityPlans: state => {
      return state.validityPlans;
    },
    getBasePrice: state => {
      return state.basePrice;
    }
  },
  mutations: {
  	channgeIsLoginState(state, payload){
		  state.isLogin = payload;
	  },
    channgeUserState(state, payload){
      state.user = payload;
    },
    changePanel(state, payload){
      state.panel = payload;
    },
    changePanelData(state, payload){
      state.panelData = payload;
    },
    validityPlansPayload(state, payload){
      state.validityPlans = payload;
    },
    basePricePayload(state, payload){
      state.basePrice = payload;
    }
  },
  actions: {
  	changLoginStatus(context, payload){
		  context.commit('channgeIsLoginState', payload);
	  },
    setUser(context, payload){
      context.commit('channgeUserState', payload);
    },
    setPanel(context, payload){
      context.commit('changePanel', payload);
    },
    setPanelData(context, payload){
      context.commit('changePanelData', payload);
    },
    setValidityPlans(context, payload){
      context.commit('validityPlansPayload', payload);
    },
    setBasePrice(context, payload){
      context.commit('basePricePayload', payload);
    }
  },
  modules: {},
});
